<div class="status-editor-row">
    <div class="error-status {{ canChange ? getStatusOption(selectedStatus).css : status.css }}">
        <select *ngIf="canChange; else statusText" class="form-control form-control-sm" [(ngModel)]="selectedStatus"
            [attr.aria-label]="'lblStatus' | translate">
            <option *ngFor="let option of statusList" [ngValue]="option.value">{{ option.text | translate }}</option>
        </select>
        <ng-template #statusText>
            <span class="error-status-text">{{ status.text | translate }}</span>
        </ng-template>
    </div>
    <button *ngIf="canChange" type="button" class="btn btn-primary btn-sm status-update-btn"
        [disabled]="selectedStatus === item.status" (click)="onUpdateStatus()" translate>lblUpdateStatus</button>
</div>
<div class="status-updated-info" *ngIf="updatedText">{{ updatedText }}</div>
